import React, { Component } from 'react';
import { matchPath } from 'react-router';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as DocumentsActions } from 'store/ducks/documents';

import { Validate } from 'common';
import { Page, Breadcrumbs } from 'components';
import { Form } from 'pages/Documents/components';

class Edit extends Component {
  state = {
    data: {
      document: {},
      situation: '',
    },
    errors: {},
    loading: true,
    breadcrumbs: [
      { name: 'Home', to: '/' },
      { name: 'Documentos', to: '/documents' },
      { name: 'Editar', to: '' },
    ],
  };

  componentDidMount() {
    const { getDocumentRequest } = this.props;
    getDocumentRequest(this.handleGetID());
  }

  componentDidUpdate(oldProps) {
    const { data } = this.state;
    const { document } = this.props;

    if (oldProps.document.loading && !document.loading) {
      const values = {
        ...data,
        ...document.data.attributes,
        id: document.data.id,
      };

      this.setState({
        data: values,
        loading: false,
      });
    }
  }

  handleGetID = () => {
    const match = matchPath(this.props.location.pathname, { path: '/documents/:id/edit' });
    return match.params.id;
  };

  handleChange = data => {
    const { errors } = this.state;

    this.setState({ data });

    Object.keys(errors).length && this.handleValidate();
  };

  handleValidate = () => {
    const { data } = this.state;

    const rules = {
      title: {
        required: true,
      },

      description: {
        required: true,
      },

      discount: {
        required: true,
      },
    };

    const validate = Validate(data, rules);
    this.setState({ errors: validate.errors });

    return validate.valid;
  };

  handleSave = () => {
    // if (!this.handleValidate()) return null;

    // const { data } = this.state;
    // const { updateDocumentRequest } = this.props;

    // updateDocumentRequest(this.handleGetID(), {
    //   user_document_request: {
    //     user_document_id: data.id,
    //     user_document_request_reason_id: this.handleGetID(),
    //     situation: data.situation,
    //   },
    // });
  };

  render() {
    const { data, errors, breadcrumbs, loading } = this.state;
    const { update } = this.props;
    const { filters } = this.props.location;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Form
          data={data}
          loading={loading}
          errors={errors}
          edit
          saving={update.loading}
          onChange={this.handleChange}
          onSave={this.handleSave}
          filters={filters}
        />
      </Page>
    );
  }
}

const mapState = state => ({
  document: state.documents.detail,
  update: state.documents.update,
});

const mapActions = dispatch => bindActionCreators(DocumentsActions, dispatch);

export default connect(
  mapState,
  mapActions,
)(Edit);
